import Panel from '../../../common/layout/Panel'
import DataResource from '../../../common/v4/DataResource';

const TTSVoicesList = () => {
    const data = {
        url: '/admin/settings/tts-voices',
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        onclick: 'link',
        link: '/settings/tts_voices/{id}',
        metadata: [
            {
                source: 'id',
                label: 'ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'name',
                label: 'Name',
                type: 'text',
            },
            {
                source: 'description',
                label: 'Description',
                type: 'text',
            },
            {
                source: 'gender',
                label: 'Gender',
                type: 'text',
            },
            {
                source: 'provider',
                label: 'Provider',
                type: 'text',
            },
            {
                source: 'provider_id',
                label: 'Provider ID',
                type: 'text',
            },
            {
                source: 'speed',
                label: 'Speed',
                type: 'number',
            },
            {
                source: 'enabled',
                label: 'Status',
                type: 'boolean',
            },
            {
                source: 'has_recording',
                label: 'Has Recording',
                type: 'boolean',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title="TTS Voices">
            <DataResource
                addButtonText="Create TTS Voice"
                addButtonLink="/settings/tts_voices/create"                    
                data={data}
            />
        </Panel>
    )
}

export default TTSVoicesList;
